<template>
    <div class="ChildsCoalition">
        <top-component></top-component>
        <div class="Coalition-title">
            <!-- <div class="Coalition-title-font">地方版出版社</div> -->
            <div class="Coalition-title-font">地方社</div>
        </div>
        <div class="Coalition-content">
            <!-- <div class="Coalition-contentFor" v-for="(item, index) in dataAll">
        <div class="Coalition-contentFor-title">{{item.title}}</div>
        <div class="Coalition-contentFor-content" v-for="(item1, index) in item.childrens" :key="index">
          &emsp;{{item1.name}}
        </div>
      </div> -->
            <div
                class="Coalition-contentFor"
                v-for="(item, index) in mainlyPlace"
                :key="index"
            >
                <div class="Coalition-contentFor-title">{{ item.title }}</div>
                <div
                    class="Coalition-contentFor-content"
                    v-for="(item, index) in item.child"
                    :key="index"
                    @click="placeClick(item)"
                >
                    &emsp;{{ item.publisher }}
                </div>
                <el-pagination
                    v-show="form.total > 36"
                    class="page-wrap"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="form.pageNum"
                    :page-size="form.pageSize"
                    layout="prev, pager, next, jumper"
                    :total="form.total"
                >
                </el-pagination>
            </div>
        </div>
        <bottom-component></bottom-component>
    </div>
</template>

<script>
import BottomComponent from "../Components/BottomComponent.vue";
import TopComponent from "../Components/TopComponent.vue";
import { searchpageCity } from "@/api/img";
import Cookies from "js-cookie";
import Axios from "@/api/diyaxios";

export default {
    name: "PublisherChildsPlaces",
    data() {
        return {
            form: {
                pageNum: 1,
                pageSize: 36,
                total: 0,
            },
            mainlyPlace: [],
            // dataAll: [
            //   {
            //     title: '河南出版社',
            //     childrens: []
            //   },
            //   {
            //     title: '河北出版社',
            //     childrens: []
            //   }
            // ],
            childrens: [],
            index: null,
        };
    },
    async mounted() {
        let vm = this;
        Cookies.get("title");
        await vm.AddressApiData();
    },
    watch: {
        index: function (val) {
            let vm = this;
            this.$nextTick(() => {
                let dom = document.getElementsByClassName(
                    "Coalition-contentFor"
                );
                window.scrollTo(0,dom[val].offsetTop)
            });
        },
    },
    methods: {
        scroll(id) {
            let dom = document.getElementsByClassName("Coalition-contentFor");
            // window.scrollTo(0,dom[id].offsetTop)
        },
        // 地方版出版社-获取子列表
        DiFangDataList() {
            let vm = this;
            var obj = {
                orgType: 3,
                pageNum: vm.form.pageNum,
                pageSize: vm.form.pageSize,
                province: Cookies.get("title"),
            };
            // searchpageCity(obj).then(response => {
            // //   console.log(response)
            //   if (response && response.entities) {
            //     this.childrens = response.entities
            //     this.form.total = response.total;
            //   }
            // })
            Axios.post(
                "/org/action/page",
                { params: obj },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
                .then((res) => {
                    if (res.data) {
                        this.childrens = res.data.child;
                        this.form.total = res.data.total;
                    }
                })
                .catch((err) => {});
        },
        AddressApiData() {
            // searchlist().then(response => {
            //   this.mainlyPlace = response.result // 地方版出版社
            // })
            let vm = this;
            // 省份
            // Axios.get('/sxtucaihui/areas/action/search/list').then(res => {
            //   let d = res.data;
            //   vm.mainlyPlace = d.result;
            // }).catch(res => {
            //     console.log( res.msg || '查询数据出错，请稍后重试');
            // });
            // 地方版出版社
            let obj = {
                type:1
            }
            Axios.post( "/exhibitionPublisher/action/listAll" , { params: obj }).then((res) => {
                    let d = res.data;
                    vm.mainlyPlace = d;
                    vm.index = this.$route.query.id;
                })
                .catch((res) => {
                    console.log(res.msg || "查询数据出错，请稍后重试");
                });
        },
        handleSizeChange(val) {
            this.form.pageSize = val;
            this.DiFangDataList();
        },
        handleCurrentChange(val) {
            this.form.pageNum = val;
            this.DiFangDataList();
        },
        // 跳转到具体的商品列表
        placeClick(item) {
            console.log(item)
            //this.$router.push({ name: 'LookPublishingPagesType', query: {obj: JSON.stringify({gid: item.gid, pubname: item.orgName, goodsType: 1 })}})
            if (item.publisherId !== null) {
                const { href } = this.$router.resolve({
                    name: "LookPublishingPagesType",
                    query: {
                        obj: JSON.stringify({
                            gid: item.unionGid,
                            pubname: item.publisher,
                            goodsType: 1,
                            showchubanshe:'8899',
                        }),
                    },
                });
                window.open(href, "_blank");
            } else {
                this.$message({
                    message: "数据异常，请稍后再试",
                    type: "error",
                });
            }
            // Cookies.set('gid', item.gid)
            // Cookies.set('goodsType', 1)
        },
    },
    components: {
        BottomComponent,
        TopComponent,
    },
};
</script>

<style scoped lang="scss">
.page-wrap {
    &.el-pagination {
        text-align: right;
    }
}
.ChildsCoalition {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
}

/* 1 */
.Coalition-title {
    height: 90px;
    width: 100%;
    background-image: url("../../assets/images/TopChild.png");
}

.Coalition-title-font {
    width: 1180px;
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: calc(50% - 590px);
    color: rgba(0, 0, 0, 1);
    font-size: 24px;
    font-weight: 600;
}

/* 2 */
.Coalition-content {
    width: 1180px;
    // height: 500px;
    margin-left: calc(50% - 590px);
}

.Coalition-contentFor {
    margin-top: 20px;
}

.Coalition-contentFor-title {
    color: rgba(0, 0, 0, 1);
    font-size: 18px;
    margin-left: 5px;
    height: 40px;
    display: flex;
    align-items: center;
    margin-top: 20px;
}

.Coalition-contentFor-content {
    width: 190px;
    height: 40px;
    display: inline-block;
    line-height: 40px;
    border-radius: 4px;
    margin-left: 5px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    margin-top: 10px;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Publisher-ChildsPlaces.vue